export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-2xl text-background-50 block mb-4">草民影院</span>
            <p className="text-sm text-background-50/50 leading-relaxed">
              高清电影与超清电视剧在线观影平台，提供1080P蓝光画质，高清不卡、流畅不缓冲、即点即看。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '手机观映', href: '#app' },
                { label: '最新动态', href: '#updates' },
                { label: '热播榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-background-50/55 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              {['动作大片', '悬疑烧脑', '喜剧合家欢', '科幻巨制'].map((cat) => (
                <span key={cat} className="text-sm text-background-50/55 whitespace-nowrap">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/35">
            草民影院 &copy; {new Date().getFullYear()} 版权所有
          </p>
          <p className="text-xs text-background-50/30">
            高清电影 · 超清电视剧 · 蓝光画质 · 1080P在线
          </p>
        </div>
      </div>
    </footer>
  );
}